// Taken from: https://stackoverflow.com/a/6470794/9925284
export function arrayMove<T>(arr: T[], fromIndex: number, toIndex: number) {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);

    return arr;
}
